import {
  DATE_TIME_FORMATS,
  DatePeriodPresets,
  DateTimeCustom,
  formatDatePeriod,
  formatDateString,
} from '@work4all/utils/lib/date-utils/formatDateString';

export type IDateCellProps = {
  value: string;
  column: {
    cellParams: {
      spanEnd?: string;
      format?: string; //https://github.com/moment/luxon/blob/master/docs/formatting.md#table-of-tokens
      wholeDayIndicator: string; //field that determines if this is to be considered without time
    };
  };
  row: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    original: any;
  };
};

export const DateCell: React.FC = (props: IDateCellProps) => {
  const {
    value,
    column: { cellParams },
    row: { original: rowData },
  } = props;

  let endValue;
  if (cellParams && cellParams.spanEnd && rowData[cellParams.spanEnd]) {
    endValue = rowData[cellParams.spanEnd];
  }

  if (
    Object.values(DatePeriodPresets).includes(
      cellParams?.format as DatePeriodPresets
    )
  ) {
    if (value && endValue) {
      return formatDatePeriod(
        cellParams?.format as DatePeriodPresets,
        value,
        endValue,
        rowData['isWholeDay']
      );
    } else {
      return '-';
    }
  }

  return formatDateString(
    value,
    DATE_TIME_FORMATS[cellParams?.format] ?? DateTimeCustom.DATE_SIMPLE_2YEAR
  );
};
